<template>
  <div>
    
    <div class="login">
      <b-modal
        v-model="modalShow"
        hide-footer
        dialog-class="modal-width"
        content-class="login-content"
        header-class="login-header"
        centered
        no-stacking
        no-close-on-backdrop
        hide-backdrop
        no-close-on-esc
        hide-header-close
        hide-header
      >
        <div align="center">
          <img src="./../assets/logo1.png" alt="Logo" />
        </div>

        <b-container>
          <b-row class="mt-3">
            <b-col sm="12" md="12" lg="12">
              <div class="pr-4 loginBox">
                <div>
                  
                  <div class="login-err mt-2">{{ loginError }}</div>
                  <!-- <template v-else class="login-err mt-2"> {{loginError}}</template> -->
                </div>

                <b-form @submit="onSubmit" class="mt-3" id="loginForm">
                  <b-form-group id="input-group-1">
                    <div class="input-field">
                      <input
                        type="text"
                        id="email"
                        v-model="loginForm.email"
                        placeholder=" "
                        required
                        class="form-control"
                      />
                      <label for="email">Email address</label>
                    </div>
                  </b-form-group>
                  <b-form-group id="input-group-2">
                    <div class="input-field">
                      <input
                        type="password"
                        id="password"
                        v-model="loginForm.password"
                        required
                        placeholder=" "
                        class="form-control"
                      />
                      <label for="password">Password</label>
                    </div>
                  </b-form-group>

                  <b-row>
                    <b-col md="6" sm="12" class="mt-3 p-0 btn-green">
                      <b-button
                        type="submit"
                        id="btnLogin"
                        block
                        variant="primary"
                        :disabled="saveLoadingIcon"
                        >Login
                        <b-spinner
                          v-if="saveLoadingIcon"
                          label="Spinning"
                          small
                          class="ml-2"
                        ></b-spinner
                      ></b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { BModal, VBModal } from "bootstrap-vue";
import router from "./../router";
import { mapState, mapGetters, mapActions } from "vuex";
import { HTTP } from "../helpers/http-common";
import { APIURLS } from "../helpers/apiUrls";

export default {
  name: "Login",
  data() {
    return {
      accessToken: null,
      toggleSocial: false,
      modalShow: true,
      saveLoadingIcon: false,
      loginForm: {
        email: "",
        password: "",
        rememberMe: false,
      },
      forgotForm: {
        email: "",
      },
    };
  },
  components: {},
  computed: {
    ...mapState({
      loginError: (state) => state.login.loginError,
      alreadySignUp: (state) => state.login.alreadySignUp,
      showNotRegistered: (state) => state.login.showNotRegistered,
    }),
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo) {
      if (userInfo.rememberMe) {
        this.loginForm = userInfo;
      }
    }
  },
  // mounted() {
  //   console.log(window, "test");
  // },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (userInfo) {
        if (!this.loginForm.rememberMe) {
          localStorage.removeItem("userInfo");
        }
      }
      this.saveLoadingIcon = true;
      this.$store
        .dispatch("login/loginAction", {
          email: this.loginForm.email,
          password: this.loginForm.password,
          rememberMe: this.loginForm.rememberMe,
        })
        .then((res) => {
          this.saveLoadingIcon = false;
        })
        .catch((error) => {
          this.saveLoadingIcon = false;
        });
    },
    onClickSignUp() {
      router.push("/signup");
    },
    onChangeUserInput(event) {
      if (this.loginError !== null) {
        this.loginError = null;
        this.$store.commit("login/setLoginError", null);
      }
      // +4;
    },

    // postForgotMail({ commit, state }, parms) {
    //   HTTP.post(`api/UserProfile/ForgotPassword?emailAddress=${parms}`)
    //     .then((response) => {
    //       alert("Password reset link sent your mail id");
    //       this.$router.go();
    //     })
    //     .catch((error) => {
    //       alert(error.response.data);
    //     });
    // },

    onEmailSend() {
      this.saveLoadingIcon = true;
      HTTP.post(
        `${APIURLS.onEmailSend}${this.forgotForm.email}`
      )
        .then((response) => {
          this.saveLoadingIcon = false;
          this.$store.commit("dashboard/setCustomToastData", {
            message: false,
            key: "RESET_PASSWORD_EMAIL",
            type: "success",
          });
          setTimeout(() => {
            this.$router.go();
          }, 500);
        })
        .catch((error) => {
          this.saveLoadingIcon = false;
          this.$store.commit("dashboard/setCustomToastData", {
            message: error.response.data
              ? error.response.data
              : error.response.statusText,
            key: false,
            type: "danger",
          });
        });
      //this.$store.dispatch("dashboard/postForgotMail", this.forgotForm.email);
    },
    onClickClose() {
      this.$router.go();
    },
    onCloseSignUp() {
      this.$store.commit("login/setAlreadySignUp", null);

      router.push("/signup");
    },
  },
};
</script>
<style scoped lang="scss">
.login-content {
  padding: 40px !important;
}
h5 {
  text-align: center;
}

.login {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #144c3d;
  background-size: cover;
}
.login-btn {
  font-size: 16px;
  color: #fff;
  background-color: #004d44;
}

.font-16px {
  font-size: 16px;
}
.login-err {
  color: red;
  font-size: 16px;
}
.z-index-2 {
  z-index: 2;
}

#btnLogin {
  width: 175px;
  height: 48px;
}

.btn-green {
  button {
   
    font-size: 16px;
    color: #fff;
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button:hover {
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button:focus,
  button.focus {
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button:not(:disabled):not(.disabled):active:focus {
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button.disabled,
  button:disabled {
    background-color: #f0f0f0;
    color: black;
  }
}
p.font-16px {
  margin: 30px 0 10px;
}


@media screen and (min-width: 768px) and (max-width: 1024px) {
  .signup-colum {
    margin-top: 20px;
  }
}

@media screen and (max-width: 767px) {
  .container {
    padding: 0 !important;
  }

  .signup-colum {
    max-width: 91%;
  }
}
.password {
  flex-direction: row-reverse;
}
</style>
